const message = {
  qr_sample: '样品寄出了，请注意查收',
  qr_video: '视频发布后请告诉我',
  qr_commission: '佣金可以再谈',
  qr_thanks: '感谢合作',
  load_failed: '会话加载失败',
  pending_reply_failed: '待回复数量加载失败',
  message_load_failed: '消息加载失败',
  archived_toast: '会话已存档，可在「已存档」中找到',
  restored_toast: '会话已恢复到收件箱',
  starred_toast: '已加入星标',
  unstarred_toast: '已取消星标',
  star_failed: '星标更新失败',
  archive_failed: '存档更新失败',
  mark_read: '标为已读',
  marked_read: '已标为已读',
  mark_read_failed: '标为已读失败',
  offline: '离线',
  starred: '已星标',
  star: '星标',
  view_profile: '查看资料',
  profile_missing: '暂无达人资料',
  title: '私信',
  refresh_failed: '刷新失败',
  history_failed: '历史消息加载失败',
  template_soon: '话术模板即将上线',
  empty: '还没有消息，发一条打个招呼吧',
  profile_title: '达人资料',
  inbox: '收件箱',
  broadcast: '群发任务',
  quota_tip: '达人回复前最多发 {{limit}} 条',
  today_quota: '剩余额度',
  quota_shop_label: '店铺',
  quota_mail_label: '邮件',
  quota_unlimited: '不限',
  quota_shop_detail: '店铺剩余 {{remaining}} / {{total}}，套餐 {{plan}}，加量 {{addon}}，已用 {{used}}',
  quota_mail_detail: '邮件剩余 {{remaining}} / {{total}}，套餐 {{plan}}，加量 {{addon}}，已用 {{used}}',
  quota_mail_unlimited_detail: '邮件不限次数，套餐 {{plan}}，加量 {{addon}}，已用 {{used}}',
  quota_reset: '套餐额度至 {{time}}',
  quota_load_failed: '额度加载失败',
  create_broadcast: '创建群发任务',
  filter_all: '全部',
  unread: '未读',
  unreplied: '未回复',
  archived: '已存档',
  refresh: '刷新',
  mark_all_read: '全部标为已读',
  more: '更多',
  search_placeholder: '搜索达人 / 消息',
  no_match: '没有匹配的会话',
  empty_inbox: '暂无会话',
  tiktok_talent: 'TikTok 达人',
  tiktok_dm: 'TikTok 私信',
  location: '位置',
  session_messages: '会话消息',
  message_count: '{{count}} 条',
  last_message: '最近消息',
  session_status: '会话状态',
  pending: '待回复',
  unbound_hint: '此达人尚未与本店绑定。邀请达人绑定，建立长期合作关系。',
  start_invite: '发起定向邀约',
  send_bind: '发送绑定邀请',
  view_homepage: '查看个人主页',
  restore: '恢复会话',
  archive: '存档会话',
  hidden_product: '不展示',
  col_task: '任务',
  col_progress: '进度',
  col_status: '状态',
  col_reply: '回复',
  col_product: '商品卡',
  col_actions: '操作',
  task_total: '共 {{count}} 个',
  list_hint: '群发走任务队列，回复进「收件箱」。发送前自动剔除黑名单 / 近 7 天已触达 / 退订达人。',
  detail_title: '群发任务 · {{name}}',
  reply_rate: '回复率',
  created_at: '创建时间',
  status_sending: '发送中',
  status_queued: '排队',
  status_done: '完成',
  status_paused: '已暂停',
  campaign_QUEUED: '排队中',
  campaign_SENDING: '发送中',
  campaign_COMPLETED: '已完成',
  campaign_PARTIAL_FAILED: '部分失败',
  campaign_CANCELLED: '已取消',
  campaign_load_failed: '群发任务加载失败',
  success_count: '成功送达',
  fail_count: '失败',
  reply_count: '已回复',
  name_fallback: '群发',
  quota_warn: '已创建，今日剩余额度 {{count}} 条，超出部分将顺延到明天发送',
  created: '群发任务已创建，{{count}} 位达人进入发送队列',
  create_title: '创建私信群发任务',
  task_name: '任务名称',
  task_name_placeholder: '请输入任务名称',
  task_name_required: '请输入任务名称',
  body_required: '请填写发送正文',
  send_body: '发送正文',
  template_placeholder: '请选择话术',
  template_empty: '当前店铺没有私信话术',
  product_empty: '当前店铺没有可挂载的商品',
  product_id: '商品 ID',
  product_id_placeholder: '请输入商品 ID',
  product_id_required: '请输入商品 ID',
  create_failed: '群发任务创建失败',
  create: '创建',
  selected_skip: '已选 {{count}} 位达人，发送前自动剔除黑名单 / 近 7 天已触达',
  show_product: '是否展示商品卡',
  pick_product_card: '选择商品卡（{{shop}}）',
  price_rate: '{{price}} · 佣金 {{rate}}%',
  queue_hint: '群发进入任务队列，稍后由后台发送；达人回复会进入「收件箱」。',
  preview_image: '[图片]',
  preview_file: '[附件] {{name}}',
  blocked_archived: '会话已存档，恢复后可继续发送',
  blocked_quota: '今日私信额度已用完（{{limit}} 条），明日 0 点重置',
  blocked_limit: '对方回复前最多发送 {{limit}} 条，已发 {{sent}}/{{limit}}，请等待达人回复',
  send_unavailable: '发送消息接口尚未接入',
  send_failed: '消息发送失败',
  send_success: '消息已发送'
};

export default message;
